import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PAGE as pagePropType, CONTENT_ITEM } from 'config/types/prop';
import { SINGLE } from 'config/types/content/component';
import { PAGE as pageContentType } from 'config/types/content';
import { options } from 'config/reactRedux';
import { createGetContentItemBySlug } from 'selectors/createGetContentItem';
import { getRelatedContentItemsByItem } from 'selectors/relatedItemSelectors';
import { createGetComponentByContentItem } from 'selectors/createGetComponent';
import Meta from 'components/meta';
import HeaderLinks from 'components/headerLinks';
import withLoader from 'components/hoc/withLoader';

const Page = ({
  page,
  component: PageComponent,
  related,
}) => {
  const {
    metadata: {
      canonicalUrl,
      languageHreflang,
      headerMeta,
      headerTitle,
    },
  } = page;

  return (
    <div className="page">
      {headerMeta && <Meta metaTags={headerMeta} title={headerTitle} />}
      <HeaderLinks
        canonicalUrl={canonicalUrl}
        languageHreflang={languageHreflang}
      />
      <PageComponent
        page={page}
        related={related}
      />
    </div>
  );
};

Page.propTypes = {
  page: PropTypes.shape(pagePropType).isRequired,
  component: PropTypes.elementType.isRequired,
  related: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape(CONTENT_ITEM),
    ),
  ).isRequired,
};

const getPost = createGetContentItemBySlug(pageContentType);

const mapStateToProps = (state, props) => {
  const page = getPost(state, props);
  const loading = state.active.loading.content || !page;
  const getComponent = createGetComponentByContentItem(page, SINGLE);
  const related = getRelatedContentItemsByItem(state, page);

  return {
    page,
    loading,
    component: getComponent(state),
    related,
  };
};

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

export default withRedux(withLoader(Page));
